import request from '@/utils/request'

export function webLogin(data) {
	return request({
		module: 'center',
		url: '/login',
		method: 'post',
		data: data
	})
}



// WEBPACK FOOTER //
// ./src/api/center/login.js